import React from 'react';
import { FaBriefcase, FaUserCog, FaAward, FaUserFriends } from 'react-icons/fa';

  
const counter = [
    { 
        id: 1, 
        icon: <FaBriefcase />,
        title: 'projects',
        count: '500',
    },
    {
        id: 2,
        icon: <FaUserCog />,
        title: 'workers',
        count: '100',
    },
    {
        id: 3,
        icon: <FaAward />,
        title: 'awards',
        count: '20',
    },
    {
        id: 4,
        icon: <FaUserFriends />,
        title: 'clients',
        count: '200',
    },
 
];

export default counter;